/*============================================================================
Product-related functionality for innerwise shop
==============================================================================*/

/*============================================================================
Check if BOGOS Offers (Bundles or Quantity Break) are available, if yes, then display relevant accordion
==============================================================================*/

(function() {
  // Only run on product pages with offers section
  function initBogosAccordions() {
    // Get the parent container
    const productOffers = document.querySelector(".product-offers");
    if (!productOffers) return;
  
    // Get both accordions
    const bundleAccordion = document.querySelector("#bundle-accordion");
    const quantityAccordion = document.querySelector("#quantity-accordion");
  
    // Initially hide both accordions and the container
    if (bundleAccordion) bundleAccordion.style.display = "none";
    if (quantityAccordion) quantityAccordion.style.display = "none";
    productOffers.style.display = "none";
  
    // Widget selectors for reuse
    const SELECTORS = {
      bundleWidget: "#bogos-bundle-view .bogos-bundles-widget",
      quantityWidget: "#bogos-bundle-quantity-break-view .bogos-bundles-quantity-break-widget",
      bundleView: "#bogos-bundle-view",
      quantityView: "#bogos-bundle-quantity-break-view"
    };
  
    // Keep track of widget states
    const state = {
      bundleWidgetFound: false,
      quantityWidgetFound: false,
      checksDone: false
    };
  
    function checkWidgets() {
      // Check for actual content in each view
      const bundleWidget = document.querySelector(SELECTORS.bundleWidget);
      const quantityWidget = document.querySelector(SELECTORS.quantityWidget);
  
      // Update our tracking variables
      if (bundleWidget) state.bundleWidgetFound = true;
      if (quantityWidget) state.quantityWidgetFound = true;
  
      // Update UI based on widget presence
      updateAccordionVisibility();
    }
  
    function updateAccordionVisibility() {
      // Bundle accordion visibility
      if (bundleAccordion) {
        bundleAccordion.style.display = state.bundleWidgetFound ? "block" : "none";
      }
  
      // Quantity accordion visibility
      if (quantityAccordion) {
        quantityAccordion.style.display = state.quantityWidgetFound ? "block" : "none";
      }
  
      // Show the container if at least one widget is found
      productOffers.style.display = (state.bundleWidgetFound || state.quantityWidgetFound) ? "block" : "none";
    }
    
    // Set up MutationObserver to detect when widgets are added to the DOM
    function setupObservers() {
      // Create observers for both widget containers
      const bundleViewElement = document.querySelector(SELECTORS.bundleView);
      const quantityViewElement = document.querySelector(SELECTORS.quantityView);
      
      const observerConfig = { 
        childList: true, 
        subtree: true 
      };
      
      // Observer callback
      const callback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if our widgets are now available
            checkWidgets();
          }
        }
      };
      
      // Create and start observers
      const observer = new MutationObserver(callback);
      
      if (bundleViewElement) {
        observer.observe(bundleViewElement, observerConfig);
      }
      
      if (quantityViewElement) {
        observer.observe(quantityViewElement, observerConfig);
      }
      
      // Also observe the parent in case views are added dynamically
      observer.observe(productOffers, observerConfig);
      
      return observer;
    }
  
    // Progressive enhancement approach with decreasing intervals
    const checkIntervals = [0, 250, 500, 1000];
    
    checkIntervals.forEach((delay, index) => {
      setTimeout(() => {
        checkWidgets();
        // Mark as done on the last check
        if (index === checkIntervals.length - 1) {
          state.checksDone = true;
          updateAccordionVisibility();
        }
      }, delay);
    });
  
    // Also check when page is fully loaded
    window.addEventListener("load", checkWidgets);
    
    // Set up observers for dynamic content
    const observer = setupObservers();
    
    // Return cleanup function
    return function cleanup() {
      if (observer && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
    };
  }
  
  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBogosAccordions);
  } else {
    initBogosAccordions();
  }
})();

/*============================================================================
PRODUKT DETAIL SEITE: INVENTORY STATUS NEBEN PREIS SCHIEBEN
==============================================================================*/

(function() {
  // Only run on product pages
  if (!window.location.pathname.includes("/products/")) return;
  
  // Function to move inventory status next to price
  function moveInventoryNextToPrice() {
    const priceElement = document.querySelector(".product__block--price");
    const inventoryElement = document.querySelector(".product__block--inventory");
    
    // Only proceed if both elements exist and aren't already wrapped
    if (!priceElement || !inventoryElement || 
        priceElement.parentNode.classList.contains("price-and-inventory")) {
      return;
    }
    
    // Create wrapper and move elements
    const wrapper = document.createElement("div");
    wrapper.className = "price-and-inventory";
    
    // Insert wrapper before price element
    priceElement.parentNode.insertBefore(wrapper, priceElement);
    
    // Move price and inventory into wrapper
    wrapper.appendChild(priceElement);
    wrapper.appendChild(inventoryElement);
  }
  
  // Run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveInventoryNextToPrice);
  } else {
    moveInventoryNextToPrice();
  }
  
  // Also run when Shopify sections are reloaded
  document.addEventListener("shopify:section:load", moveInventoryNextToPrice);
})();

/*============================================================================
QUICKVIEW: INVENTORY STATUS NEBEN PREIS SCHIEBEN
==============================================================================*/

(function() {
  // Function to move inventory status next to price in quickview
  function moveQuickviewInventoryNextToPrice() {
    // Find all product info containers in quickview context
    const productInfoContainers = document.querySelectorAll('[data-section*="quick-view"] .product__info-container');
    
    productInfoContainers.forEach(container => {
      const priceElement = container.querySelector(".product__block--price");
      const inventoryElement = container.querySelector(".product__block--inventory");
      
      // Only proceed if both elements exist and aren't already wrapped
      if (!priceElement || !inventoryElement || 
          priceElement.parentNode.classList.contains("price-and-inventory")) {
        return;
      }
      
      // Create wrapper and move elements
      const wrapper = document.createElement("div");
      wrapper.className = "price-and-inventory";
      
      // Insert wrapper before price element
      priceElement.parentNode.insertBefore(wrapper, priceElement);
      
      // Move price and inventory into wrapper
      wrapper.appendChild(priceElement);
      wrapper.appendChild(inventoryElement);
    });
  }
  
  // Helper function to handle element availability
  function handleQuickviewUpdate() {
    // Initial attempt
    moveQuickviewInventoryNextToPrice();
    
    // Additional attempts with delays to catch dynamic loading
    setTimeout(moveQuickviewInventoryNextToPrice, 100);
    setTimeout(moveQuickviewInventoryNextToPrice, 500);
  }
  
  // Run when drawer content is shown
  document.addEventListener("drawer:handleAfterShow", function(e) {
    handleQuickviewUpdate();
  });
  
  // Run when quickview content is loaded
  document.addEventListener("quickview:loaded", handleQuickviewUpdate);
  
  // Run when sections are reloaded (catches Shopify section updates)
  document.addEventListener("shopify:section:load", function(e) {
    if (e.target.querySelector('[data-section*="quick-view"]')) {
      handleQuickviewUpdate();
    }
  });
  
  // Observe DOM changes in quickview drawers
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.target.closest('[data-section*="quick-view"]')) {
        handleQuickviewUpdate();
        break;
      }
    }
  });
  
  // Function to start observing
  function startObserving() {
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }
  
  // Start observing when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }
})();

